export const supportedMimeTypes = [
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "video/mp4"
];

export const bannerCacheKey = "banner-cache";